<div class="login-page" [style.background-image]="'url(' + bgLoginPath + ')'">
  <div class="login-page__container">
    <div class="login-card">
      <div class="login-card__header">
        <img src="assets/icon/logo-sso.png" alt="Cổng xác thực tập trung" class="login-card__logo">
        <h1 class="login-card__title">Yêu cầu hỗ trợ khôi phục tài khoản</h1>
        <p class="login-card__subtitle" *ngIf="!submitted">
          Dành cho trường hợp mất cả mật khẩu lẫn thiết bị Authenticator (không còn mã khôi phục).
          Quản trị viên sẽ xác minh danh tính của bạn trước khi xử lý.
        </p>
      </div>

      <form *ngIf="!submitted" [formGroup]="form" class="login-card__form" (ngSubmit)="submit()">
        <div class="login-field">
          <hbt-input-text
            class="login-input"
            [defaultInput]="true"
            labelText="Tên đăng nhập"
            placeholderText="Nhập tên đăng nhập"
            formControlName="loginName"
            [type]="isSubmitted && f['loginName'].errors ? 'error' : 'default'"
            [showError]="isSubmitted && f['loginName'].errors !== null"
            [errors]="f['loginName'].errors"
            [errorDefs]="[{ errorName: 'required', errorDescription: 'Bắt buộc nhập tên đăng nhập' }]">
          </hbt-input-text>
        </div>

        <div class="login-field">
          <hbt-input-text
            class="login-input"
            [defaultInput]="true"
            labelText="Email liên hệ"
            placeholderText="Email để quản trị viên liên hệ xác minh"
            formControlName="contactEmail"
            [type]="isSubmitted && f['contactEmail'].errors ? 'error' : 'default'"
            [showError]="isSubmitted && f['contactEmail'].errors !== null"
            [errors]="f['contactEmail'].errors"
            [errorDefs]="[
              { errorName: 'required', errorDescription: 'Bắt buộc nhập email liên hệ' },
              { errorName: 'email', errorDescription: 'Email không hợp lệ' }
            ]">
          </hbt-input-text>
        </div>

        <div class="login-field">
          <hbt-input-text
            class="login-input"
            [defaultInput]="true"
            labelText="Lý do (tuỳ chọn)"
            placeholderText="VD: Mất điện thoại, quên mật khẩu, đã hết mã khôi phục"
            formControlName="reason">
          </hbt-input-text>
        </div>

        <div class="captcha-group" style="justify-content: center; display: flex; margin-bottom: 16px">
          <div id="recaptcha-recovery"></div>
        </div>

        <button type="submit" class="login__btn" nz-button [disabled]="isLoading">Gửi yêu cầu</button>
        <div class="login-links">
          <a (click)="backToLogin()" class="login-links__item">Quay lại đăng nhập</a>
        </div>
      </form>

      <div *ngIf="submitted" class="login-card__form">
        <p class="login-card__subtitle" style="text-align: center; margin-bottom: 20px">
          Đã gửi yêu cầu thành công. Quản trị viên sẽ liên hệ qua email bạn cung cấp để xác minh và xử lý.
        </p>
        <button type="button" class="login__btn" nz-button (click)="backToLogin()">Quay lại đăng nhập</button>
      </div>

      <p class="login-card__footer">
        © 2026 • {{copyright}}
      </p>
    </div>
  </div>
</div>
